<template>
  <div class="row provision-table" :class="showSettlementTypeClass()">
    <div class="col s12 headline center">
        <h1>Tabela wynagrodzeń</h1>
    </div>

    <div class="col s12 indicator-row" v-if="showProvisionFor('cps')">
      <stats-indicator icon="mfind-icon-wallet"
        :stats="showProvisionFor('cps')" unit="zł">
        <template slot="header">
          <h6 class="provision-type-info">
            CPS
            <span data-balloon-pos="up" data-balloon="Sprzedana polisa">
              <i class="mfind-icon-info icon"></i>
            </span>
          </h6>
        </template>
      </stats-indicator>
    </div>

    <div class="col s12 indicator-row" v-if="showProvisionFor('cpl')">
      <stats-indicator icon="mfind-icon-wallet"
        :stats="showProvisionFor('cpl')" unit="zł">
        <template slot="header">
          <h6 class="provision-type-info" >
            CPL
            <span data-balloon-pos="up" data-balloon="Potwierdzona kalkulacja">
              <i class="mfind-icon-info icon"></i>
            </span>
          </h6>
        </template>
      </stats-indicator>
    </div>

    <Loader :loading="getUserPending"/>
  </div>
</template>

<script>
import StatsIndicator from '@/components/statsIndicator'
import Loader from '@/components/loader'
import { mapGetters } from 'vuex'
export default {
  components: { StatsIndicator, Loader },
  methods: {
    showProvisionFor (settlementType) {
      return this.getUserSettlementType(settlementType)
    },
    showSettlementTypeClass () {
      return this.getUserSettlementType()
    }
  },
  computed: {
    ...mapGetters([ 'getUserPending', 'getUserSettlementType' ])
  }
}
</script>

<style lang="scss">
@import 'src/stylesheets/variables';
@import 'src/stylesheets/mixins';
.provision-table {
  .provision-type-info {
    font-size: 16px;

    .icon {
      transition: 1s;
      &:hover {
        color: $not-important-text-color;
      }
    }
  }

  &.cps.cpl {
    .indicator-row {

      &:last-child:after {
        @include indicator-row-after;
      }

      @media #{$medium-only} {
        width: 50%;

        &:nth-last-child(2):before {
          @include indicator-row-before;
        }

        &:last-child:after {
          content: none
        }
      }
    }
  }

  @media #{$large-and-up} {
    .headline {
      margin-top: 30px
    }

    .stats-indicator {
      padding: 1.6rem 0;
    }

    .indicator-row {
      height: 8rem;
    }

    .indicator-row:last-child {
      margin-bottom: 15px
    }
  }
}
</style>



// WEBPACK FOOTER //
// provisionTable.vue?241dfb40